import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import OutputExcelTravelerModal from "./OutputExcelTravelerModal"
import {
  isLTPM,
  FileDownloadStatus,
  withApplicationConfig,
} from "../../../components/shared_components_registration"

const registration = {
  export_excel_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.export.excel.traveler" }) : "Export Excel Traveler",
}

export const ExcelTravelerModal = ({ intl, show, setShow, runData, customOnHide }) => {
  const [showDownloadStatusModal, setShowDownloadStatusModal] = useState(false)
  const [downloadStatusMessage, setDownloadStatusMessage] = useState("")

  return (
    <>
      {show && (
        <OutputExcelTravelerModal
          show={show}
          onHide={() => {
            setShow(false)
            customOnHide && customOnHide()
          }}
          run={runData}
          setDownloadStatusMessage={setDownloadStatusMessage}
          setShowDownloadStatusModal={setShowDownloadStatusModal}
          intl={intl}
        />
      )}
      {showDownloadStatusModal && downloadStatusMessage && (
        <FileDownloadStatus
          message={downloadStatusMessage}
          onHide={() => {
            setShowDownloadStatusModal(false)
            setDownloadStatusMessage(null)
          }}
          showDownloadStatusModal
        />
      )}
    </>
  )
}

function ExcelTravelerButton({
  runData,
  intl,
  isBtn = true,
  btnVariant = "outline-primary",
  showText = false,
  config = {}, // From withApplicationConfig - Currently only used for LTPM
}) {
  const widgetTitle = registration.export_excel_label(intl)
  const excelSpan = (
    <span>
      <span className={"fa fa-file-excel-o"} aria-hidden={"true"} />
      {showText && <>&nbsp;{widgetTitle}</>}
    </span>
  )

  const [show, setShow] = useState(false)
  const [allowTravellerGeneration, setAllowTravellerGeneration] = useState(true)
  useEffect(() => {
    if (isLTPM && config?.user?.permissions) {
      // Handle use case on LTPM where certain user types shouldn't be able to download a run excel traveller
      setAllowTravellerGeneration(config.user.permissions.includes("can_generate_excel_traveller_export"))
    }
  }, [config])

  return (
    <>
      {allowTravellerGeneration && (
        <>
          <ExcelTravelerModal intl={intl} show={show} setShow={setShow} runData={runData} />
          {isBtn ? (
            <Button
              variant={btnVariant}
              title={widgetTitle}
              onClick={(e) => {
                e.preventDefault()
                setShow(true)
              }}
            >
              {excelSpan}
            </Button>
          ) : (
            <span
              title={widgetTitle}
              style={{
                cursor: "pointer",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
              onClick={() => setShow(true)}
            >
              {excelSpan}
            </span>
          )}
        </>
      )}
    </>
  )
}

export default withApplicationConfig(ExcelTravelerButton)
